import React, { memo } from 'react';
import { useParams } from 'react-router-dom';

import LoanEditorChatDrawerInner from './components/LoanEditorChatDrawerInner';

const LoanEditorChatDrawer = memo(() => {
  const { applicationId } = useParams();

  if (!applicationId) {
    return null;
  }

  return <LoanEditorChatDrawerInner applicationId={applicationId} key={applicationId} />;
});
export default LoanEditorChatDrawer;
